<template>
<div class="table-container" id="searchTableContainer">

  <div class="table-header" id="searchTable-ContainerTable-Header">
    <div class="container-fluid almost-fluid" id="searchTable-container">
      <table class="table" id="searchTable-table">
        <caption class="accessibly-hidden">{{ 'CUSTOMER_MANAGEMENT' | translate }} table header</caption>
        <thead id="searchTable-tableHead">
          <tr>
            <th scope="col">{{ 'RELATION_ID' | translate }}</th>
            <th scope="col">{{ 'NAME' | translate }}</th>
            <th scope="col">{{ 'BATCH' | translate }}</th>
            <th scope="col">{{ 'CRM_LINK' | translate }}</th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
  
  <div class="table-body" id="searchTable-tableBody">
    <div class="container-fluid almost-fluid" id="searchTable-tableBody-container">
      <table class="table table-hover" id="searchTable-tableBody-table">
        <caption class="accessibly-hidden">{{ 'CUSTOMER_MANAGEMENT' | translate }}</caption>
        <thead class="d-none" id="searchTable-tableBody-tableHead"><tr><th scope="col"></th></tr></thead> <!-- sonar accesibility rules require a th element -->
        <tbody id="searchTable-tableBody-innerTableBody">
          <search-table-row v-for="row in customerList"
                            :key="row.uniqueId"
                            :customerObj="row"
                            :id="'searchTable-searchTableRow-'+row.uniqueId">
          </search-table-row>
          <tr v-if="customerList.length < 1" id="searchTable-searchTableRowData">
            <td colspan="4" class="text-center" id="searchTable-searchTableRowData">{{ 'msg.NO_CUSTOMERS_FOUND' | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
</template>

<script>
import SearchTableRow from '@/components/customers/SearchTableRow';

export default {
  components: { SearchTableRow },
  props: ['customerList']
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/search-table";
</style>



// WEBPACK FOOTER //
// src/components/customers/SearchTable.vue